import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { ShareButtons } from "@/components/ShareButtons";
import { scrollToId } from "@/lib/scroll";

export const InsightDialog = ({ article, onClose }) => (
  <Dialog open={!!article} onOpenChange={(o) => !o && onClose()}>
    <DialogContent
      data-testid="insight-dialog"
      className="max-h-[88vh] w-[calc(100%-2rem)] max-w-3xl overflow-y-auto rounded-none border-gold/25 bg-ink p-0 text-white"
    >
      {article && (
        <article className="px-6 py-10 sm:px-12 sm:py-14">
          <p className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
            <span>{article.category}</span>
            <span className="h-px w-6 bg-gold/50" aria-hidden="true" />
            <span className="text-slate-500">
              {article.date} · {article.readTime}
            </span>
          </p>
          <DialogTitle className="mt-6 font-display text-2xl font-normal leading-tight tracking-tight sm:text-4xl">
            {article.title}
          </DialogTitle>
          <DialogDescription className="mt-6 text-base leading-relaxed text-slate-300">{article.excerpt}</DialogDescription>
          <div className="mt-6 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-6">
            <ShareButtons article={article} />
            <Link
              to={`/insights/${article.slug}`}
              data-testid="insight-dialog-open-page"
              className="link-underline flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400 hover:text-white"
            >
              Open full page <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
          </div>
          <div className="mt-6 space-y-6 pt-4">
            {article.body.map((p, i) => (
              <p key={i} className="text-sm leading-[1.85] text-slate-300 sm:text-base">
                {p}
              </p>
            ))}
          </div>
          <div className="mt-12 flex flex-col items-start gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
              Want to talk this through for your organisation?
            </p>
            <button
              type="button"
              data-testid="insight-dialog-cta"
              onClick={() => {
                onClose();
                setTimeout(() => scrollToId("book"), 250);
              }}
              className="btn-sweep btn-sweep-light border border-accent bg-accent px-6 py-3 font-mono text-[11px] uppercase tracking-[0.22em] text-ink"
            >
              Book a consultation
            </button>
          </div>
        </article>
      )}
    </DialogContent>
  </Dialog>
);
